<!--批量更新stock的指定信息-->
<template>
    <div class="xform">
        <div v-for="(batch, i) in batchs" :key="i" style="margin-bottom:10px;">
            <el-row :gutter="10" type="flex" justify="space-between" align="center" >
                <el-col :span="12">
                    <el-select v-model="batch.iptLabel" size="mini" clearable :placeholder="msg('请选择')" @change="getSelectes(batch)">
                        <template v-for="(t, idx) in types">
                            <el-option v-if="hasPermission(t.auth)" :label="t.label" :value="idx" :key="idx"></el-option>
                        </template>
                    </el-select>
                </el-col>
                <el-col :xs="15">
                    <div style="display:flex;">
                        <div style="white-space:nowrap;">{{msg('待更新的值')}}： </div>
                        <el-select v-if="[5,6].indexOf(batch.iptLabel)>-1" 
                            size="mini" :placeholder="msg('请选择')" v-model="batch.iptValue">
                            <el-option v-for="item in batch.selectes" :label="item.label" :value="item.value" :key="item.value"></el-option>
                        </el-select>
                        <el-input v-else style="max-width:200px;"
                            size="mini" :placeholder="msg('输入要更新的值')" v-model="batch.iptValue" >
                        </el-input>
                    </div>
                </el-col>
                <el-col :xs="15">
                    <el-link :underline="false" type="danger" @click="batchs.splice(i, 1);" title="删除">
                        <i class="el-icon-delete"></i>
                    </el-link>
                </el-col>
            </el-row>
        </div>
        <div class="cell-tool" style="text-align:center;">
            <el-button type="primary" @click="addBatch()" plain size="mini" >添加更多</el-button>
        </div>
        <div style="display:flex;margin-top:20px;margin-bottom:10px;align-items:center;justify-content:center;">
            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定更新')}}</span></el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "StockBatchUpdate",
    components: {
    },
    computed: {
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
    },
    mounted(){
        
        let temps = this.dicts.stockStatus;

        //转运中；待验中；已清中；已提货；转配送；待备货；待打包；已揽收；已发货；已弃件；已寄回；已寄出；
        let needs = [13,20,35,40,45,50,55,60,65,70,75];
        this.statuses = [];
        temps.forEach(s => {
            if(needs.indexOf(s.value)>-1){
                this.statuses.push(s);
            }
        });

        this.batchs = [
            {
                iptLabel:null,
                iptValue:null,
            }
        ]

    },
    data(){
        return {
            batchs:[],
            type: null,
            types: [
                {label: this.msg('班次'), auth: 'stock:batchFieldBanci'},       //0
                {label: this.msg('转运'), auth: 'stock:batchFieldZhuanyun'},    //1
                {label: this.msg('待验'), auth: 'stock:batchFieldDaiyan'},  //2
                {label: this.msg('清关'), auth: 'stock:batchFieldQingguan'},    //3
                {label: this.msg('提货'), auth: 'stock:batchFieldTihuo'},   //4
                {label: this.msg('货态更新'), auth: 'stock:batchFieldStatus'},  //5
                {label: this.msg('订单卖场'), auth: 'stock:batchFieldPlatform'}, //6
                {label: this.msg('资料备注2'), auth: 'stock:batchFieldMessages2'},//7
                {label: this.msg('客服备注'), auth: 'stock:batchFieldRemark6'}, //8
                {label: this.msg('过期备注'), auth: 'stock:batchFieldMessages3'},//9
            ],
            selectes: [],
            isShowTable:false,
            statuses: [],
            expCompanys:[],
        }
    },
    props:{
        datas: Array
    },
    methods:{
        init(){
            this.batchs = [
                {
                    iptLabel:null,
                    iptValue:null,
                }
            ]
        },
        addBatch(){

            if(this.batchs.length >= 3){
                this.$message(this.msg('更新的字段数量已达到上限'));
                return;
            }

            this.batchs.push(
                {
                    iptLabel:null,
                    iptValue:null,
                }
            )
        },
        getSelectes(batch){

            if(batch.iptLabel == 5){//货态修正
                batch.selectes = this.statuses;
            }else if(batch.iptLabel == 6){//订单卖场
                batch.selectes = this.dicts.orderPlatforms;
            }
            return [];
        },
        onSubmit(){

            let retur1 = false;
            let retur2 = false;
            this.batchs.forEach(d => {
                if(!d.iptLabel && d.iptLabel != 0){
                    retur1 = true;
                }
                if(!d.iptValue && d.iptValue != 0){
                    retur2 = true;
                }
            })

            if(retur1){
                this.$message(this.msg('请选择要更新的字段'));
                return;
            }

            if(retur2){
                this.$message(this.msg('请输入要更新的值'));
                return;
            }

            let para = {
                keys:this.batchs,
                ids:this.datas.map(e => e.id)
            }
            var _this = this;
            this.$axios.post(this.$kit.api.stock.batchUpdateNew, para)
                .then((result) => {
                    this.$message(result.msg || _this.msg('更新失败'));

                    // if(result.status){
                    //     // _this.$message(result.msg || _this.msg('更新成功'));
                    //     for(let i = 0; i<result.data.length; i++){
                    //         this.datas[i].result = result.data[i];
                    //     }
                    // }
                });
        },
    }
}
</script>

<style lang="scss" scoped>
.xform{
    box-sizing: border-box;
}
.xctrl{
    text-align:center;
    padding:15px;
    width:100%;
}

</style>